import { X } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { useEffect } from 'react';

export default function InAppNotificationItem({ notification, onClose }) {
	const { title, message, toast_type } = notification;
	const shouldReduce = useReducedMotion();

	const initial = shouldReduce ? { opacity: 0 } : { y: -12, opacity: 0 };
	const animate = shouldReduce ? { opacity: 1 } : { y: 0, opacity: 1 };
	const exit = shouldReduce ? { opacity: 0 } : { y: -12, opacity: 0 };

	useEffect(() => {
		const timer = setTimeout(() => {
			onClose();
		}, 10000);
		return () => clearTimeout(timer);
	}, [onClose]);

	return (
		<motion.div
			role="status"
			aria-live="polite"
			className="
         w-[369px] h-[60px] rounded-md shadow-lg
        bg-[#313131] ring-1 ring-black/5
        p-2 flex items-center gap-2 text-white
      "
			initial={initial}
			animate={animate}
			exit={exit}
			transition={{ type: 'spring', stiffness: 420, damping: 28, mass: 0.6 }}
			layout
		>
			<div
				className="w-[4px] h-[36px] rounded-sm"
				style={{ backgroundColor: toast_type === 'info' ? '#1D56C8' : '#FB5607' }}
			/>
			<div className="min-w-0 flex-1">
				{title && <div className="text-sm font-semibold truncate">{title}</div>}
				{message && (
					<div className="text-sm mt-0.5 truncate leading-tight" title={message}>
						{message}
					</div>
				)}
			</div>

			<button
				onClick={onClose}
				className="h-6 w-6 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition"
				aria-label="Dismiss notification"
				title="Dismiss"
			>
				<X className="text-white/50" strokeWidth={1.25} />
			</button>
		</motion.div>
	);
}
